export default __webpack_public_path__ + "src/assets/nft-placeholder.f46584ea8f33b0ba825240227d43e176.png";